import { useMicrophoneStatus } from "@/features/MicrophoneManager/hooks/useMicrophoneStatus";
import { ProgressBarInline } from "@enxcs/dap-ui-stratos";
import { memo } from "react";

interface VolumeBarProps {
  stream: MediaStream | null;
}

export const VolumeBar = memo(({ stream }: VolumeBarProps) => {
  const { volumePercentage } = useMicrophoneStatus(stream, { volumeUpdateThreshold: 2 });

  return <ProgressBarInline value={volumePercentage} progressTitle="Microphone Volume" />;
});
